import m from "../../geodata/es2015/panamaHigh";
window.am4geodata_panamaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/panamaHigh.js
// module id = null
// module chunks = 